var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      attrs: {
        row: "",
        "justify-center": "",
        "grid-list-md": "",
        color: _vm.color
      }
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", persistent: "", "max-width": _vm.maxWidth },
          model: {
            value: _vm.coDialog,
            callback: function($$v) {
              _vm.coDialog = $$v
            },
            expression: "coDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "py-0" },
            [
              _vm.title
                ? _c(
                    "v-card-title",
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass:
                            "primary--text pa-2 mr-3 modal-title--icon",
                          attrs: { "d-flex": "", xs1: "" }
                        },
                        [
                          _vm.icon
                            ? _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v(_vm._s(_vm.icon))
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h2", { staticClass: "headline ml-1 primary--text" }, [
                        _vm._v(_vm._s(_vm.title))
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      !_vm.hideCloseButton
                        ? _c(
                            "v-btn",
                            {
                              attrs: { flat: "", icon: "" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.handleClose(true)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("icon-close")])],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.coDialog
                ? _c(
                    "v-card-text",
                    { staticClass: "my-0 py-0 form-container" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.dtIsValid,
                            callback: function($$v) {
                              _vm.dtIsValid = $$v
                            },
                            expression: "dtIsValid"
                          }
                        },
                        [_vm._t("default")],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _vm.actionPosition === "center"
                ? _c(
                    "v-card-actions",
                    { staticClass: "ml-4 mr-5" },
                    [
                      _c(
                        "div",
                        { staticStyle: { float: "left" } },
                        [
                          _vm._t("action-left"),
                          _vm._v(" "),
                          _vm.showCreateAnother
                            ? _c("v-checkbox", {
                                attrs: {
                                  label: _vm.createAnotherLabel
                                    ? _vm.createAnotherLabel
                                    : _vm.$t(_vm.lblSetting.lblCreateAnother)
                                },
                                model: {
                                  value: _vm.coCreateAnother,
                                  callback: function($$v) {
                                    _vm.coCreateAnother = $$v
                                  },
                                  expression: "coCreateAnother"
                                }
                              })
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            "align-center": "",
                            "justify-end": "",
                            row: "",
                            "fill-height": ""
                          }
                        },
                        [
                          _c("v-btn", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: _vm.lblSetting.btnCancel,
                                expression: "lblSetting.btnCancel"
                              }
                            ],
                            attrs: { color: "greyDarker", flat: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.handleClose($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._t("action-between"),
                          _vm._v(" "),
                          _c("base-modal-submit-btn", {
                            attrs: {
                              form: _vm.$refs.form,
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              title:
                                _vm.submitBtnTitle ||
                                _vm.$t(_vm.lblSetting.btnRecord)
                            },
                            on: { record: _vm.handleRecord }
                          }),
                          _vm._v(" "),
                          _vm._t("action")
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [_vm._t("action-right")],
                        2
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _vm.coCreateAnother
                        ? _c("v-switch", {
                            attrs: {
                              label: _vm.$t(_vm.lblSetting.lblCreateAnother)
                            },
                            model: {
                              value: _vm.dtCreateAnother,
                              callback: function($$v) {
                                _vm.dtCreateAnother = $$v
                              },
                              expression: "dtCreateAnother"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-btn", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: _vm.lblSetting.btnCancel,
                            expression: "lblSetting.btnCancel"
                          }
                        ],
                        attrs: { color: "greyDarker", flat: "" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.handleClose($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm._t("action"),
                      _vm._v(" "),
                      _c("base-modal-submit-btn", {
                        attrs: {
                          form: _vm.$refs.form,
                          disabled: _vm.disabled,
                          loading: _vm.loading,
                          title:
                            _vm.submitBtnTitle ||
                            _vm.$t(_vm.lblSetting.btnRecord)
                        },
                        on: { record: _vm.handleRecord }
                      })
                    ],
                    2
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5f61ce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f61ce2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/modal/template.html
// module id = null
// module chunks = 